import styled from 'styled-components';

export const Container = styled.aside`
  background-color: ${(props) => props.theme.colors.darkGreen};
  display: flex;
  flex-direction: column;
  padding: 64px 32px;
  row-gap: 32px;
  color: white;
  height: 100%;

  a {
    color: white;
    text-decoration: underline transparent;
    transition: all 200ms;

    &:hover {
      text-decoration-color: white;
    }
  }
`;

export const About = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  img {
    height: 150px;
    width: 150px;
    border-radius: 50%;
  }

  .username {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 4px;

    .name {
      font-size: 1.4rem;
      font-weight: bold;
    }
  }

  p {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 950px) {
    p {
      text-align: center;
    }
  }
`;

export const UserNumbers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 0.9rem;

  .number {
    font-weight: bold;
  }
`;

export const Info = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  font-size: 1rem;

  li,
  li > a {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }

  svg {
    display: flex;
    align-items: center;
    min-width: 16px;
  }

  @media screen and (max-width: 950px) {
    display: none;
  }
`;
